import script from "./BuyButton.vue?vue&type=script&setup=true&lang=js"
export * from "./BuyButton.vue?vue&type=script&setup=true&lang=js"

import "./BuyButton.vue?vue&type=style&index=0&id=62b9a799&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-62b9a799"]])

export default __exports__